import InternshipCard from './InternshipCard'

const ActionInternshipCard = ({ displaySectorSelector, internship, tooltip, onUpdate }) => {
  return (
    <div className='internship-info-old'>
      <InternshipCard
        internship={internship}
        legend={tooltip && 'internship_request_card.legend'}
      />
    </div>
  )
}

export default ActionInternshipCard
